import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { EdgeId, NodeSn } from '@ipfabric/utils';
import type { DeviceViewNodeEntity } from 'components/DeviceView/deviceViewTypes';
import { getDeviceViewEntityNodeId } from 'components/DeviceView/helpers/getDeviceViewEntityNodeId';
import { closeDeviceViewEntity } from 'components/DeviceView/model/commands/closeDeviceViewEntity';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import type { NodeStableData } from 'components/Graph/model/selectors/selectNodesStableData';
import { findNodeIdByNodeSn } from '../pathLookup/helpers/findNodeIdByNodeSn';
import { unhighlightEdges } from '../pathLookup/unhighlightEdges';
import { showNodeDetail } from '../showNodeDetail';

interface ResetPathInspectorTabCommand {
  currentDeviceViewEntity?: DeviceViewNodeEntity;
  edgeId: EdgeId;
  edgesToUnhighlight: EdgeId[];
  followingNode?: NodeStableData;
  nodeSn: NodeSn;
  selectedIncomingEdgeId?: EdgeId;
  selectedOutgoingEdgeId?: EdgeId;
}

export const resetPathInspectorTab: GraphCommandFactory<
  ResetPathInspectorTabCommand
> = (cmdContext, dispatch) => (command) => {
  dispatch(unhighlightEdges, { edges: command.edgesToUnhighlight });

  if (command.followingNode === undefined) {
    stumble('unknown node');
    return;
  }

  if (command.currentDeviceViewEntity !== undefined) {
    cmdContext.getDeviceView().dispatch(closeDeviceViewEntity, {
      deviceViewElement: 'node',
      deviceViewEntityId: command.currentDeviceViewEntity.id,
    });
  }
  const currentNodeId = findNodeIdByNodeSn(
    cmdContext.getState().graph,
    command.nodeSn,
  );
  dispatch(showNodeDetail, {
    nodeId: command.followingNode.id,
    selectedIncomingEdgeId: command.selectedIncomingEdgeId,
    selectedOutgoingEdgeId: command.selectedOutgoingEdgeId,
  });
  // close original node after opening following node to prevent resetting
  // settings in closeDeviceViewEntity
  if (currentNodeId !== null && currentNodeId !== command.followingNode.id) {
    cmdContext.getDeviceView().dispatch(closeDeviceViewEntity, {
      deviceViewElement: 'node',
      deviceViewEntityId: getDeviceViewEntityNodeId(command.nodeSn),
    });
  }
};
